import axios from 'axios'
import { NODE_BASE_URL, getAxiosOptions } from './serviceHelper'

export const dependencyMapService = {
  getListDataDep: async (user, activityTemplateId) => {
    return await axios.get(
      `${NODE_BASE_URL}/template/dependency-map/activity/${activityTemplateId}`,
      getAxiosOptions(user)
    )
  },
  getFieldTemplateDep: async (user, activityTemplateId) => {
    return await axios.get(
      `${NODE_BASE_URL}/template/field/dependency-map/activity/${activityTemplateId}`,
      getAxiosOptions(user)
    )
  },
  addFieldTemplateDep: async (user, fieldTemplateId, dep) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/template/field/dependency-map/${fieldTemplateId}`,
        dep,
        getAxiosOptions(user)
      )
    ).data
  },
}
